<template>
	<div>
		<filter-panel labelWidth="100px" :data="groups" @search="filterChange"></filter-panel>

		<data-list
			v-loading="loading"
			:table-style="{ name: 'webclient' }"
			:data="data"
			:columns="column"
			:btnList="btnList"
			:page="page"
			@sort-change="sortChange"
			:page-size="page.pageSize"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
		></data-list>

		<el-drawer
			ref="drawer"
			title="广告"
			size="50%"
			:visible.sync="drawer"
			custom-class="custom_class"
			:show-close="false"
			:with-header="false">
			<div class="close_drawer"><span @click="$refs.drawer.closeDrawer()">收起</span></div>
			<div class="info_box">
				<div class="info">
					<div class="info_tit_test">
						<div class="info_tit info_http">
							<div v-for="(item, index) in drawerCardDetail" :key="index">
								<span v-for="(url, id) in [...drawerDetail[item.text] || []].slice(0,item.length)" :key="id" :class="item.tit ? item.tit : 'other'">{{ (item.tip||'')+url+(item.separate == ' | ' && id == 2 ? '' : (item.separate || '')) }}</span>
							</div>
						</div>
						<!-- <span class="info_tit info_http">广告：https://lanhuapp.com/web/#/item/project/detailDetach?pid=0140ebd3-2370-4463-bc61-68c475c4a43d&image_id=da2149d7-1745-4ba5-b6d4-e11462055139&tid=e2d3de88-659e-4ebc-b4ee-e99e20b66c74&project_id=0140ebd3-2370-4463-bc61-68c475c4a43d&fromEditor=true&type=image</span> -->
						<span class="edit" @click="edit(drawerDetail)">编辑</span>
					</div>
					<div class="info_list">
						<span>状态：{{getStatus}}</span>
						<span>类型：{{drawerDetail.typeDesc  || '-'}}</span>
						<span>所属广告系列：{{drawerDetail.campaignName || '-'}}</span>
						<span>所属广告：{{drawerDetail.adGroupName || '-'}}</span>
					</div>
				</div>
				<div class="info">
					<div class="info_tit">
						最终到达网址
					</div>
					<div class="setting http" v-for="(item, index) in drawerDetail.finalUrls" @click="openUrl(item)" :key="index">
						{{item || '-'}}
					</div>
				</div>
        <div class="info">
					<div class="info_tit">
						广告标题
					</div>
					<div v-show="drawerDetail.titles && drawerDetail.titles.length == 0">-</div>
					<div class="setting" v-for="(ite, ind) in drawerDetail.titles" :key="ind">
						{{ '标题' + (ind+1) + '：' + ite }}
					</div>
				</div>
				<div class="info">
					<div class="info_tit">
						广告说明
					</div>
					<div v-show="drawerDetail.titlesDesc && drawerDetail.titlesDesc.length == 0">-</div>
					<div class="setting" v-for="(it, ind) in drawerDetail.titlesDesc" :key="ind">
						{{ '说明' + (ind+1) + '：' + it }}
					</div>
				</div>
			</div>
		</el-drawer>
		<customColumnModal
			:visible.sync="visible"
			nameKey="customsName"
			:list="lists"
			:customChecked="customChecked"
			@getColumn="getColumn">
		</customColumnModal>
		<form-dialog
			:dialogVisible.sync="dialogVisible"
			:destroy-on-close="true"
			ref="formDialog"
			:formData="formData"
			dialogWidth="600px"
			:dialogTitle="title"
		>
			<dialogfooter slot="footer" @onclose="handleClose" @confirm="submit"></dialogfooter>
		</form-dialog>
	</div>
</template>
<script>
import { adSeriesStatus, accountsStatus } from '@/common/dictionary.js';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import customColumnModal from '@/components/iglobalwin/formComponents/customColumn/custom-column-modal.vue';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import googleads from '@/backend/services/googleAds/googleAds.js';
// import mixinsWatch from '@/client/mixinsWatch/mixinsWatch';
import formDialog from '@/components/webManage/formDialog.vue';
import dialogfooter from '@/components/crm/crm-dialog-footer.vue';
import { validRequired, requiredCustom } from '@/common/elementValid.js';
const list = listPageCreate({
	searchConfig: {
		api: api.googleAds.getAdgroupAdList,
		method: 'POST',
	},
	getQuery(data,val) {
		return _.assign({}, data, {
			startDate: val.time ? val.time[0] : '',
			endDate: val.time ? val.time[1] : '',
			id: val.$route.query.adGroupId ? val.$route.query.adGroupId : '0', // 广告组id
			campaignId: val.$route.query.adSeriesId ? val.$route.query.adSeriesId : '', // 广告系列id
			status: JSON.parse(localStorage.getItem('adStatus')).status,
			adGroupStatus: JSON.parse(localStorage.getItem('adStatus')).adGroupStatus,
			adStatus: JSON.parse(localStorage.getItem('adStatus')).adStatus,
		});
	},
});

export default {
	props: {
		time: {
			type: Array,
			default: function () {
				return [];
			},
		}
	},
	mixins: [list],
	data() {
		return {
			column: [],
			groups: {},
			btnList: [],
			drawer: false,
			drawerDetail: {},
			drawerCardDetail: [
				{
					text: 'finalUrls', // 展示字段
					length: 1, // 展示条数
					tip: '广告 · ', // 前缀
				},
				{
					text: 'titles',
					length: 3,
					separate: ' | ', // 分隔
					tit: 'tit', // 颜色类名
				},
				{
					text: 'titlesDesc',
					length: 3,
					separate: '。', // 分隔
				},
			],
			visible: false,
			dialogVisible: false,
			title: '',
			formData: {},
			lists: [],
			customChecked: [],
		};
	},

	computed: {
		getStatus() {
			return accountsStatus[this.drawerDetail.status]
		},
	},

	watch: {
    time: {
      handler () {
				this.query();
      },
      // immediate: true,
			deep: true,
    },
  },

	methods: {
		filterChange(val) {
			localStorage.setItem('adStatus',JSON.stringify(val));
			this.query();
		},
		requestData() {
			this.setGroups();
		},
		setGroups() {
			let that = this;
			this.groups = {
				others: [
					{
            tagName: 'sky-select',
            placeholder: '请选择广告系列状态',
            label: '广告系列状态',
            // inputTitle: '广告系列状态',
            tagFormatStyle: true,
            // 'collapse-tags': true,
            prop: 'status',
            multiple: true,
            value: ['ENABLED', 'PAUSED'],
            options: adSeriesStatus,
          },
          {
            tagName: 'sky-select',
            placeholder: '请选择广告组状态',
            label: '广告组状态',
            // inputTitle: '广告组状态',
            tagFormatStyle: true,
            // 'collapse-tags': true,
            prop: 'adGroupStatus',
            multiple: true,
            value: ['ENABLED', 'PAUSED'],
            options: adSeriesStatus,
          },
					{
            tagName: 'sky-select',
            placeholder: '请选择广告状态',
            label: '广告状态',
            // inputTitle: '广告状态',
            tagFormatStyle: true,
            // 'collapse-tags': true,
            prop: 'adStatus',
            multiple: true,
            value: ['ENABLED', 'PAUSED'],
            options: adSeriesStatus,
          },
				],
			};

			this.btnList = [
				{
					name: '新建广告',
					position: 'left',
					attribute: {
						type: 'primary',
						size: 'small',
					},
					btnClick: this.addAdvertising,
				},
        {
					name: '自定义列',
					position: 'right',
					attribute: {
						// type: 'primary',
						size: 'small',
					},
					btnClick: this.getColumn,
				},
        // {
				// 	name: '导出数据',
				// 	position: 'right',
				// 	attribute: {
				// 		type: 'primary',
				// 		size: 'small',
				// 	},
				// 	btnClick: this.exportData,
				// },
			];
			this.column = [
				{
          label: '状态',
          type: 'switchBtn',
          bind: 'status',
					fixed: "left",
          activeValue: 'ENABLED',
          inactiveValue: 'PAUSED',
          toggle(val, row) {
						that.changeStatus(val,row);
          },
        },
				{
					label: '广告',
					type: 'multipleParames',
					fixed: "left",
					minWidth: 500,
					// showOverflowTooltip: true,
					bind: [
						{
							text: 'finalUrls', // 展示字段
							length: 1, // 展示条数
							tip: '广告 · ', // 前缀
						},
						{
							text: 'titles',
							length: 3,
							separate: ' | ', // 分隔
							tit: 'tit', // 颜色类名
						},
						{
							text: 'titlesDesc',
							length: 3,
							separate: '。', // 分隔
						},
					]
				},
				{
					label: '操作',
					type: 'btnClick',
					align: 'left',
					style: 'text',
					fixed: "left",
					minWidth: 140,
					bind() {
						let arr = [
							{
								text: '详情',
								trigger: row => {
									that.openDrawer(row);
								},
							},
              {
								text: '编辑',
								trigger: row => {
									that.edit(row);
								},
								showButton(row) {
									return row.status !== 'REMOVED';
								},
							},
              {
								text: '移除',
								trigger: row => {
									that.remove(row);
								},
								showButton(row) {
									return row.status !== 'REMOVED';
								},
							},
						];

						return arr;
					},
				},
        {
					label: '广告类型',
					bind: 'typeDesc',
					minWidth: 120,
				},
        {
					label: '广告系列名称',
					bind: 'campaignName',
					minWidth: 120,
				},
        {
					label: '广告组名称',
					bind: 'adGroupName',
					showOverflowTooltip: true,
					minWidth: 120,
				},
				{
					label: '消耗(￥)',
					bind: 'cost',
					minWidth: 120,
					sort: 'cost',
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
				},
				{
					label: '展示次数',
					bind: 'impressions',
					sort: 'impressions',
					minWidth: 120,
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
				},
				{
					label: '点击次数',
					bind: 'clicks',
					sort: 'clicks',
					minWidth: 120,
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
				},
				{
					label: '转化次数',
					bind: 'conversions',
					sort: 'conversions',
					minWidth: 120,
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
				},
        {
					label: '点击率',
					bind: 'ctr',
					type: 'defaultTextUnitCustom',
					sort: 'ctr',
					minWidth: 120,
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
					click(val) {
						return ''+val.row.ctr+'%'
					}
				},
        {
					label: '点击均价(￥)',
					bind: 'averageCpc',
					sort: 'averageCpc',
					minWidth: 120,
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
				},
			];
		},
		// 查看详情
		openDrawer(row) {
			this.drawerDetail = row;
			this.drawer = true;
		},
		// exportData() {
		// 	console.log('导出数据')
		// },
		edit(row) {
			this.$refs.drawer.closeDrawer(); // 关闭详情抽屉
			this.$router.push({
				name: 'addAdVertising',
				query: {
					adSeriesId: row.campaignId,
					adSeriesName: row.campaignName,
					adGroupId: row.adGroupId,
					adGroupName: row.adGroupName,
					resourceName: row.resourceName,
					edit: row.id
				},
			});
		},
    // 跳转链接打开新窗口
    openUrl(http) {
      window.open(http, '_blank');
    },
		// 新建广告
		addAdvertising() {
			this.title = '提示';
			this.dialogVisible = true;
			this.setFormData();
		},
		// 设置新建广告弹窗数据
		setFormData() {
			this.formData = {
				adRadio: {
					label: '',
					labelWidth: '0px',
					formType: 'sky-radio',
					options: [
						{
								label: '选择已有广告系列',
								value: 1,
						},
						{
								label: '新建广告系列',
								value: 0,
						},
					],
					value: 1,
					border: true,
					prop: 'adRadio',
					rules: [validRequired('此项必填', 'change')],
				},
				adCard: {
					label: '',
					labelWidth: '0px',
					formType: 'sky-card-cascade-panel',
					value: undefined,
					isChildren: true,
					props: {
						label: 'name',
						value: 'resourceName',
						lazy: false,
					},
					// api: '',
					prop: 'adCard',
					rules: [requiredCustom('此项必填', 'change')],
					displayWith: () => {
						// 选择新建广告系列不显示
						return this.formData.adRadio.value !== 0;
					},
				},
			};
		},
		// 关闭新建广告组弹框
		handleClose() {
			this.dialogVisible = false;
			this.$nextTick(() => {
				this.$refs.formDialog.reset();
			});
		},
		submit () {
      this.$refs.formDialog.validate(async valid => {
        if (valid) {
          if(this.formData.adRadio.value == 0) {
						// 新建广告系列
						this.$router.push({
							name: 'addAdSeries',
						});
					}else {
						// 新建广告
						this.$router.push({
							name: 'addAdVertising',
							query: {
								adSeriesId: this.formData.adCard.value.adSeriesId,
								adSeriesName: this.formData.adCard.value.adSeriesName,
								adGroupId: this.formData.adCard.value.adGroupId,
								adGroupName: this.formData.adCard.value.adGroupName,
								resourceName: this.formData.adCard.value.resourceName,
							},
						});
					}
        }
      })
    },
		async changeStatus(val, row) {
      try {
        let res = await googleads.getAdgroupAdStatus({ id: row.id, adGroupId: row.adGroupId, status: val });
        if (res.status >= 200 && res.status < 400) {
          this.$message.success('更改成功');
        }
      } catch (e) {
        window.console.error(e);
        this.$message.info('更改成功');
      }
      this.query();
    },
		// 移除状态修改
		remove(row) {
			this.$confirm('确定要移除吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async() => {
				let res = await googleads.getAdgroupadRemove({ adsId: row.id, adGroupId: row.adGroupId, status: 'REMOVED' });
				if (res.status >= 200 && res.status < 400) {
					this.$message.success('移除成功');
					this.query();
				}else {
					this.$message.info('移除失败');
				}
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消移除'
				});          
			});
		},
		// 获取自定义列表数据
		async getColumn(val) {
			if(Object.prototype.toString.call(val) === '[object Array]') {
				this.visible = false;
				let arr = [];
				arr = val.map(item => {
					return {
						...item,
						type: 3
					}
				})
				await googleads.insertCustomfieldList(arr);
				// 所有列表数据
				this.getColumnLists()
			}else {
				this.visible = true;
				let res = await googleads.getCustomfieldList(3);
				// 所有列表数据
				this.lists = res.data;
			}
		},
		// 获取列表数据
		async getColumnLists() {
			// 当前用户列表自定义字段数据
			let res = await googleads.getCustomfieldUserList(3);
			this.column = this.dataConversion(res.data);
			// 所有选中自定义列表数据
			this.customChecked = res.data;
		},
		// 数据转换
		dataConversion(data) {
			let that = this, newArr = [];
			// 带排序功能列表字段
			let sortCode = ['cost','impressions','clicks','conversions','ctr','averageCpc'];
			// 单位 元
			let unitY = ['cost','averageCpc'];
			// 单位 百分比 %
			let unitPercent = ['ctr','conversionsFromInteractionsRate'];
			data.forEach(item => {
				let lab = '';
				if((unitY.indexOf(item.columnCode.split('.')[1]) != -1 || unitY.indexOf(item.columnCode.split('.')[0]) != -1)) {
					// 加上单位 元
					lab = item.columnName + ' (￥)';
				}else if((unitPercent.indexOf(item.columnCode.split('.')[1]) != -1 || unitPercent.indexOf(item.columnCode.split('.')[0]) != -1)) {
					// 加上单位 百分比 %
					lab = item.columnName + ' (%)';
				}else {
					lab = item.columnName;
				}
				let obj = {
						label: lab,
						bind: item.columnCode.split('.')[1] || item.columnCode.split('.')[0],
						// fixed: item.columnCode.split('.')[1] == 'name' ? 'left' : '',
						minWidth: 120,
						showOverflowTooltip: true,
					};
				if(item.columnCode.split('.')[1] == 'name' || item.columnCode.split('.')[0] == 'name') {
					// 当字段为广告名称时，修改type类型，增加 操作 字段列
					newArr.push(
					{
						label: lab,
						type: 'multipleParames',
						fixed: "left",
						minWidth: 500,
						// showOverflowTooltip: true,
						bind: [
							{
								text: 'finalUrls', // 展示字段
								length: 1, // 展示条数
								tip: '广告 · ', // 前缀
							},
							{
								text: 'titles',
								length: 3,
								separate: ' | ', // 分隔
								tit: 'tit', // 颜色类名
							},
							{
								text: 'titlesDesc',
								length: 3,
								separate: '。', // 分隔
							},
						]
					},
					{
						label: '操作',
						type: 'btnClick',
						align: 'left',
						style: 'text',
						fixed: "left",
						minWidth: 140,
						bind() {
							return [
								{
									text: '详情',
									trigger: row => {
										that.openDrawer(row);
									},
								},
								{
									text: '编辑',
									trigger: row => {
										that.edit(row);
									},
									showButton(row) {
										return row.status !== 'REMOVED';
									},
								},
								{
									text: '移除',
									trigger: row => {
										that.remove(row);
									},
									showButton(row) {
										return row.status !== 'REMOVED';
									},
								},
							];
						},
					});
				} else if(unitPercent.indexOf(item.columnCode.split('.')[1]) != -1 || unitPercent.indexOf(item.columnCode.split('.')[0]) != -1) {
					// 当字段为百分号单位时，增加百分号
					newArr.push({
						...obj,
						type: 'defaultTextUnitCustom',
						click(val) {
							let res =item.columnCode.split('.')[1] || item.columnCode.split('.')[0];
							if(val.row[res] != undefined) {
								return val.row[res].toFixed(2)+'%';
							}else {
								return '-'
							}
						}
					})

				} else if(item.columnCode.split('.')[1] == 'finalUrls' || item.columnCode.split('.')[0] == 'finalUrls') {
					// 最终到达网址
					newArr.push(
						{
							label: lab,
							type: 'multipleParames',
							minWidth: 320,
							// showOverflowTooltip: true,
							bind: [
								{
									text: 'finalUrls', // 展示字段
									length: 1, // 展示条数
									tip: '', // 前缀
								},
							]
						},
					)
				} else if(sortCode.indexOf(item.columnCode.split('.')[1]) != -1 || sortCode.indexOf(item.columnCode.split('.')[0]) != -1) {
					// 当字段为排序列表字段，增加排序配置
					newArr.push({
						...obj,
						sort: item.googleApiField,
						options: [
							{
								label: '由低到高',
								value: 'ASC',
							},
							{
								label: '由高到低',
								value: 'DESC',
							},
						],
					})
				}else {
					// 其他普通字段直接添加
					newArr.push(obj);
				}
			});
			// 最后在列表首部增加状态字段
			newArr.unshift(
				{
          label: '状态',
          type: 'switchBtn',
          bind: 'status',
					fixed: "left",
          activeValue: 'ENABLED',
          inactiveValue: 'PAUSED',
          toggle(val, row) {
						that.changeStatus(val,row);
          },
        }
			);
			return newArr;
		},
	},
	mounted() {
		this.requestData();
		if(!JSON.parse(localStorage.getItem('adStatus'))) {
			localStorage.setItem('adStatus',JSON.stringify({status:['ENABLED','PAUSED'],adGroupStatus:['ENABLED','PAUSED'],adStatus:['ENABLED','PAUSED']})); // 广告默认搜索条件
		}
		this.setGroups();
		if(this.$route.path.includes('accountManagement')) {
			this.groups.others[0].value = JSON.parse(localStorage.getItem('adStatus')).status || ['ENABLED','PAUSED'];
			this.groups.others[1].value = JSON.parse(localStorage.getItem('adStatus')).adGroupStatus || ['ENABLED','PAUSED'];
			this.groups.others[2].value = JSON.parse(localStorage.getItem('adStatus')).adStatus || ['ENABLED','PAUSED'];
		}
		this.getColumnLists();
		this.query();
	},
	components: { filterPanel, formDialog, dialogfooter, customColumnModal },
};
</script>
<style lang="scss">
.custom_class {
	overflow-y: auto;
	background-color: #F6F8FC;
	.el-drawer__header {
		display: none;
	}
	.close_drawer {
		line-height: 40px;
		padding-left: 20px;
		color: #3DA1FF ;
		background-color: #FFFFFF;
		&>span {
			cursor: pointer;
		}
	}
	.info_box {
		padding: 20px;
		.info {
			padding: 30px;
			margin-bottom: 10px;
			line-height: 40px;
			border-radius: 6px;
			background: #FFFFFF ;
			.info_tit_test {
				display: flex;
				justify-content: space-between;
        .info_http {
          line-height: 20px;
          flex: 1;
        }
				.edit {
					color: #3DA1FF;
					cursor: pointer;
          width: 60px;
          text-align: right;
          align-self: start;
          line-height: 1;
				}
				.tit {
					color: #409eff;
				}
			}
			.info_list{
				&>span {
					padding-right: 60px;
					word-break: break-all;
				}
			}
			.info_tit {
				font-size: 16px;
				color: #333333;
				font-weight: 600;
			}
			.setting {
				padding-top: 10px;
			}
      .http {
        color: #3DA1FF;
        cursor: pointer;
        display: inline-block;
      }
		}
	}
}
</style>
